import { useState, useEffect } from "react";
import { client } from "../sanity/client";

function Contact() {
  const [contact, setContact] = useState(null);
  useEffect(() => {
    client.fetch('*[_type == "contact"]').then((data) => {
      console.log("API CONTACT:", data[0]);
      setContact(data[0]);
    });
  }, []);
  return (
    <>
      <p>
        <span className="prompt">ziad@portfolio:</span>
        <span className="path">~</span>
        <span className="command">$ cd contact</span>
      </p>
      <div className="section">
        <div className="contact-grid">
          <div className="contact-item">
            📧 Email:
            <a href={`mailto:${contact?.email}`}>{contact?.email}</a>
          </div>
          <div className="contact-item">
            🔗 Github:
            <a href={contact?.github} target="_blank" rel="noreferrer">
              atiqueahmedziad
            </a>
          </div>
          <div className="contact-item">
            🔗 LinkedIn:
            <a href={contact?.linkedin} target="_blank" rel="noreferrer">
              atiqueahmedziad
            </a>
          </div>
          <div className="contact-item">
            📞 Phone:{" "}
            <span className="no">
              <a href={`tel:${contact?.phone}`}>{contact?.phone}</a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
export default Contact;
